export const getSelectedCompanyId = (): string | null => {
  const companyId = localStorage.getItem('selectedCompanyId');

  return companyId && companyId !== 'undefined' && companyId.trim() !== '' ? companyId : null;
};
